import React from 'react';
export const Adoptable40 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M3.73335 9.0665V7.99984H2.66669L2.66669 9.0665H3.73335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.80002 10.1332V9.0665L3.73335 9.0665L3.73335 10.1332H4.80002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.80002 9.0665V7.99984H3.73335V9.0665L4.80002 9.0665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.80002 7.99984V6.93317H3.73335L3.73335 7.99984H4.80002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.86669 11.1998V10.1332L4.80002 10.1332L4.80002 11.1998H5.86669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.86669 10.1332V9.0665H4.80002V10.1332L5.86669 10.1332Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.86669 9.0665V7.99984H4.80002V9.0665H5.86669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.86669 7.99984V6.93317H4.80002V7.99984H5.86669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.86669 6.93317L5.86669 5.8665H4.80002L4.80002 6.93317H5.86669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 12.2665V11.1998L5.86669 11.1998L5.86669 12.2665H6.93335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 11.1998V10.1332H5.86669V11.1998L6.93335 11.1998Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 10.1332V9.0665H5.86669V10.1332H6.93335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 9.0665V7.99984H5.86669V9.0665H6.93335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 7.99984L6.93335 6.93317H5.86669V7.99984H6.93335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 6.93317V5.8665H5.86669L5.86669 6.93317H6.93335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.93335 5.8665V4.79984H5.86669L5.86669 5.8665H6.93335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 13.3332V12.2665L6.93335 12.2665L6.93335 13.3332H8.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 12.2665V11.1998H6.93335V12.2665L8.00002 12.2665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 11.1998V10.1332H6.93335V11.1998H8.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 10.1332V9.0665L6.93335 9.0665V10.1332H8.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 9.0665V7.99984L6.93335 7.99984V9.0665L8.00002 9.0665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 7.99984L8.00002 6.93317L6.93335 6.93317L6.93335 7.99984L8.00002 7.99984Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 6.93317V5.8665H6.93335V6.93317L8.00002 6.93317Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 5.8665V4.79984H6.93335V5.8665H8.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00002 4.79984L8.00002 3.73317H6.93335L6.93335 4.79984H8.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 12.2665V11.1998H8.00002V12.2665L9.06669 12.2665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 11.1998V10.1332H8.00002V11.1998H9.06669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 10.1332V9.0665L8.00002 9.0665V10.1332H9.06669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 9.0665V7.99984L8.00002 7.99984V9.0665L9.06669 9.0665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 7.99984L9.06669 6.93317L8.00002 6.93317L8.00002 7.99984L9.06669 7.99984Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 6.93317V5.8665H8.00002V6.93317L9.06669 6.93317Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06669 5.8665L9.06662 4.79984H8.00002V5.8665H9.06669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 5.8665V4.79984L9.06662 4.79984L9.06669 5.8665L10.1334 5.8665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06662 4.79984L9.06662 3.73317L8.00002 3.73317L8.00002 4.79984H9.06662Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 4.79984V3.73317L9.06662 3.73317L9.06662 4.79984L10.1334 4.79984Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.06662 3.73317L9.06669 2.6665L8.00002 2.6665L8.00002 3.73317L9.06662 3.73317Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 11.1998V10.1332H9.06669V11.1998L10.1334 11.1998Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 10.1332V9.0665H9.06669V10.1332H10.1334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 9.0665V7.99984H9.06669V9.0665H10.1334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 7.99984V6.93317H9.06669L9.06669 7.99984H10.1334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 6.93317V5.8665L9.06669 5.8665V6.93317H10.1334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.1334 3.73317V2.6665L9.06669 2.6665L9.06662 3.73317L10.1334 3.73317Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.2 10.1332V9.0665H10.1334V10.1332L11.2 10.1332Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.2 9.0665V7.99984H10.1334V9.0665H11.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.2 7.99984V6.93317H10.1334V7.99984H11.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.2 6.93317V5.8665L10.1334 5.8665V6.93317H11.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.2 3.73317V2.6665L10.1334 2.6665V3.73317L11.2 3.73317Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.2 4.2665V3.19984L10.1334 3.19984V4.2665L11.2 4.2665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.2667 9.0665V7.99984H11.2V9.0665L12.2667 9.0665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.2667 7.99984V6.93317H11.2V7.99984H12.2667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.2667 6.93317V5.8665H11.2V6.93317H12.2667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.2667 4.2665V2.6665L11.2 2.6665V4.2665L12.2667 4.2665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.3334 7.99984V6.93317H12.2667V7.99984L13.3334 7.99984Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.3334 6.93317V5.8665H11.7334V6.93317H13.3334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.3334 5.8665V4.79984H11.7334V5.8665H13.3334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.3334 4.79984V3.73317H11.7334V4.79984H13.3334Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.3334 3.73317V2.66652L12.2667 2.6665L12.2667 3.73318L13.3334 3.73317Z",
        fill: "currentColor"
    }));
Adoptable40.displayName = 'Adoptable40';
export default Adoptable40;

//# sourceMappingURL=40x40.js.map